module.exports = __webpack_public_path__ + "static/media/ring-band_720x480.b41fc97b.jpg";